import React from 'react'
import '../pages/css/Home.css';
import '../pages/css/CustomSoftwareDevelopment.css';
import CaseStudy from '../pages/components/CaseStudy';

function CaseStudyPage() {
  return (
    <>
    <CaseStudy /></>
  )
}

export default CaseStudyPage